<template>
  <div>
<!--    <h3>对话列表</h3>-->
    <a-list
      item-layout="horizontal"
      :data-source="conversations"
      :loading="loading"
    >
      <a-list-item v-for="(item, index) in conversations" :key="item.id">
        <a-list-item-meta :description="item.introduction">
          <template #title>
            <span style="margin-right: 10px; color: #999;">{{ index + 1 }}</span>
            <a @click="viewConversation(item.id)">
              {{ item.name }}
            </a>
          </template>
        </a-list-item-meta>
        <div>{{ formatDate(item.updated_at) }}</div>
      </a-list-item>
    </a-list>

    <!-- 加载更多控件 -->
    <div style="text-align: center; margin-top: 20px;">
      <a-button
        v-if="hasMore && conversations.length > 0"
        @click="loadMore"
        :loading="loading"
        type="primary"
      >
        加载更多
      </a-button>
      <div v-if="!hasMore && conversations.length > 0" style="color: #999;">
        没有更多数据了
      </div>
    </div>

    <!-- 页面大小和统计信息 -->
    <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;">
      <div>
        <span>每页显示：</span>
        <a-select
          :value="pageSize"
          @change="handlePageSizeChange"          style="width: 80px;"
          size="small"
        >
          <a-select-option v-for="size in pageSizeOptions" :key="size" :value="size">
            {{ size }}
          </a-select-option>
        </a-select>
      </div>
      <div style="color: #666;">
        共 {{ conversations.length }} 条记录
      </div>
    </div>
  </div>
</template>

<script>export default {
  name: 'ChatListModal',
  props: {
    user: {
      type: String,
      default: '',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      conversations: [],
      loading: false,
      hasMore: true,
      pageSize: 10,
      pageSizeOptions: ['10', '20', '50', '100'],
      lastId: null,
      internalUser: ''
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.internalUser =  this.internalUser || this.user;
        this.resetData();
        this.fetchConversations();
      }
    },
    pageSize() {
      this.resetData();
      this.fetchConversations();
    },
    // 监听user prop变化
    user(newVal) {
      if (newVal) {
        this.internalUser = newVal;
      }
    }
  },
  mounted() {
    // 组件挂载时如果可见，立即加载数据
    if (this.visible) {
      this.internalUser = this.internalUser || this.user;
      this.fetchConversations();
    }
  },
  methods: {
    resetData() {
      this.conversations = [];
      this.hasMore = true;
      this.lastId = null;
    },

    async fetchConversations() {
      this.loading = true;
      try {
        const res = await this.$http.get('/hhemp/ai/chat-conversations', {
          params: {
            lastId: this.lastId,
            limit: this.pageSize,
            sortBy: '-updated_at',
            user: this.user
          }
        });

        const result = res.result;
        const newData = result.data || [];

        if (this.lastId) {
          // 追加数据
          this.conversations.push(...newData);
        } else {
          // 首次加载
          this.conversations = newData;
        }

        this.hasMore = result.has_more || false;

        // 更新 lastId 为最后一条记录的 ID
        if (newData.length > 0) {
          this.lastId = newData[newData.length - 1].id;
        }

      } catch (err) {
        console.error(err);
        this.$message.error('加载数据失败');
      } finally {
        this.loading = false;
      }
    },

    async loadMore() {
      if (!this.hasMore) return;
      await this.fetchConversations();
    },

    handlePageSizeChange(value) {
      this.pageSize = parseInt(value);
    },

    formatDate(timestamp) {
      const date = new Date(timestamp * 1000);
      return date.toLocaleString();
    },

    viewConversation(conversationId) {
      // 先关闭当前对话列表弹窗
      //this.$emit('close');
      // 延迟触发查看对话详情事件
      //this.$nextTick(() => {
      this.$emit('view-conversation',  {
          conversationId: conversationId,
          user: this.internalUser || this.user}
        );
      //});
    },
  }
}
</script>